import { NextHopGraphData } from './next_hop_graph_data';
import { createGraph } from '../force_directed_graph/force_directed_graph.service';
import { createAssetNextHopTreeView } from './asset_next_hop_tree_view_factory.service';
import { AssetNextHopTreeViewFactoryHelper } from './asset_next_hop_tree_view_factory_helper.service';
import { ConnectionService } from 'app/views/view_types/network/shared/connections/connection.service';
import { ViewStateService } from '../../../shared/view_state.service';

const CENTERING_PAD = 44;

export function assetNextHopTreeDirective(
    $window,
    clockHandler,
    viewStateService: ViewStateService,
    connectionService: ConnectionService,
) {
    'ngInject';
    function link($scope, element) {
        let graph = createGraph(element[0].childNodes[0]);
        let assetNextHopTreeView = createAssetNextHopTreeView(
            graph,
            new NextHopGraphData(connectionService),
            new AssetNextHopTreeViewFactoryHelper(viewStateService),
        );

        assetNextHopTreeView.graphDataUpdated(clockHandler.getCursorTimeAsJulian());

        // Update the tree every 3 seconds
        let intervalHandle = $window.setInterval(() => {
            assetNextHopTreeView.graphDataUpdated(clockHandler.getCursorTimeAsJulian());
        }, 3000);

        $scope.graphResized = function (w, h) {
            graph.doScopedUpdate(function () {
                graph.setSize(w, h - CENTERING_PAD);
            });
        };

        $scope.$on('$destroy', function () {
            $window.clearInterval(intervalHandle);
        });
    }

    return {
        restrict: 'E',
        template:
            '<div on-size-changed="graphResized" class="force-directed-graph-container"></div>',
        link: link,
    };
}
